export const habaProduct = {
  habaProductCard: {
    newTag: 'NEU',
    sustainableTag: 'Nachhaltig',
    color: 'Farben',
    personalizationBtn: 'Personalisierung wählen',
    chooseSize: 'Größe wählen',
    aiImageAlt: 'KI-generiertes Bild',
  },
  habaProductDetails: {
    descriptionSectionTitle: 'Produktdetails',
    descriptionSectionSubTitle: 'Beschreibung',
    downloadSectionTitle: 'Downloads',
    hintsSectionTitle: 'Hinweise',
    technicalData: 'Produktmerkmale',
    notificationSubscribeTitle: 'Benachrichtigung per E-Mail aktiviert',
    notificationSubscribeBody: 'Sie werden informiert, sobald das Produkt wieder verfügbar ist',
    addToCart: 'In den Warenkorb',
    personalization: 'Produkt personalisieren',
    akkuTyp: 'Akku-Typ:',
    amountType: 'Stück',
    cable: 'Netzteil/Kabel',
    batteryType: 'Batterie-Typ',
    quantity: 'Menge',
    descriptionMoreLink: 'Produktdetails',
    descriptionHeadline: 'Produktbeschreibung',
    taxDelivery: 'inkl. MwSt. /',
    taxDeliveryLink: 'Versandkosten',
    freeDelivery: 'kostenloser Versand',
    outOfStock: 'Nicht mehr verfügbar',
    shareProduct: 'Produkt teilen',
    linkCopy: 'Link kopieren',
    linkCopied: 'Link kopiert',
    linkCopyFailed: 'Kopieren des Links fehlgeschlagen',
    note: '(bitte extra bestellen)',
    notExchangeable: 'nicht wechselbar',
    isNoMoreFixedBookPrice: 'Frühere Buchpreisbindung aufgehoben',
    selectVoucherValue: 'Wert wählen',
    personalize: {
      openButton: 'Produkt personalisieren',
      justForYou: 'Nur für dich',
      title: 'Produkt personalisieren',
      remove: 'Entfernen',
      save: 'IN DEN WARENKORB',
      cannotReturn:
        'Bitte haben Sie Verständnis dafür, dass personalisierte Artikel vom Umtausch und Rückgaberecht ausgeschlossen sind.',
      inputPlaceholder: 'Bitte Wunschtext Zeile {{index}} eingeben',
      informationSpace: 'Platz für deine Angaben:',
      linesAndLength: '{{lines}} Zeile(n) à {{length}} Zeichen',
      priceLine:
        'Diesen Artikel personalisieren wir für zuzüglich <b>{{price}} je Stück</b> ganz nach deinem Wunsch.',
      script: 'Schreibschrift',
      block: 'Druckschrift',
      wrongCharacters: 'Sonderzeichen sind nicht erlaubt.',
    },
    pleaseSelectAmount: 'Bitte wählen Sie einen Betrag aus:',
    selectIndividualAmount: 'Oder wählen Sie einen individuellen Betrag:',
    amountInfo: 'Nur Beträge ohne Nachkommastellen zulässig.',
    enterAmount: 'Betrag eingeben',
    amountConfirm: 'Bestätigen',
    selectedVoucherValue: 'Ausgewählter Gutscheinwert',
    voucherValueAdjustedTitleSuccess: 'Der Betrag wurde angepasst',
    voucherValueAdjustedMessageSuccess: 'Jetzt nur noch in den Warenkorb legen',
    voucherValueAdjustedTitleError: 'Ungültige Eingabe',
    voucherValueAdjustedMessageError:
      'Der Geschenkgutscheinwert muss ein gültiges Format ohne Dezimalstellen haben',
    voucherIntervalValueAdjustedMessageError:
      'Der gewählte Wert des Geschenkgutscheins muss zwischen 10€ und 500€ sein',
    articleNumber: 'Artikelnummer',
    manufacturer: 'Hersteller',
    specifications: {
      recommendedAge: 'Altersempfehlung',
      numberOfPlayers: 'Anzahl Personen',
      playingTime: 'Spieldauer',
      playingTimeRange: 'ca. {{min}} – {{max}} Minuten',
      playingTimeSingle: 'ca. {{value}} Minuten',
      productDimensions: 'Produktabmessungen',
      weight: 'Gewicht',
      author: 'Autor*in',
      authors: 'Autor*innen',
      illustration: 'Illustration',
      dimensionAbbr: {
        height: 'H',
        width: 'B',
        depth: 'T',
        length: 'L',
      },
    },
    downloadInstructions: 'Anleitung Download',
    classificationYes: 'Ja',
    classificationNo: 'Nein',
    content: 'Inhalt',
    instructions: 'Material & Pflegehinweise',
    returnInformation: 'Kostenlose <u>Rücksendung</u> innerhalb von <b>4 Wochen</b>',
    certificate: {
      certifiedBy: 'Zertifiziert durch',
      licenceNumber: 'Lizenznummer',
    },
    ratingProduct: {
      modalButton: 'Produkt bewerten',
      rateProduct: 'Bewerte dieses Produkt',
      yourRating: 'Deine Produktbewertung*',
      ratingDescription: 'Beschreibung der Produktbewertung*',
      descriptionError:
        'Dieses Feld ist ein Pflichtfeld und muss zwischen 1 und 400 Zeichen umfassen',
      additionalInformation:
        'Durch das Absenden erklärst du dich mit den <a href="{{guidelinesUrl}}" class="font-xs font-md-s" target="_blank" rel="noopener noreferrer">HABA Richtlinien</a> für Bewertungen einverstanden.',
      submitReview: 'Bewertung absenden',
      successfulTitle: 'Vielen Dank für deine Bewertung!',
      successfulText:
        'Deine Bewertung wird nun verarbeitet. Wir werden dich per E-Mail benachrichtigen, sobald deine Bewertung auf der Produktseite sichtbar ist.',
      backToProductButton: 'Zurück zum Produkt',
    },
    sort: {
      sortBy: 'Sortiert nach',
      date: 'Datum',
      highestRating: 'Höchste Bewertung',
      lowestRating: 'Niedrigste Bewertung',
    },
    sizeTable: {
      baby: 'Babys',
      girl: 'Mädchen',
      unisex: 'Jungen',
      hat: 'Mützen',
      shoe: 'Schuhe',
      glove: 'Handschuhe',
    },
    minimumPrice: {
      bestPrice: '30-Tage-Bestpreis:',
      learnMore: 'Mehr erfahren',
      currentPriceIsTheLowestPrice:
        'Der „30-Tage-Bestpreis“ ist der niedrigste Preis, zu dem der Händler dieses Produkt in den 30 Tagen vor der letzten Preisänderung angeboten hat.',
      currentPriceIsNotTheLowestPrice:
        'Beim „30-Tage-Bestpreis“ handelt es sich um den niedrigsten Preis, zu dem der Händler dieses Produkt in den 30 Tagen vor der letzten Preisänderung angeboten hat. Aufrund vergangener Rabattaktionen kann der „30-Tage-Bestpreis“ niedriger ausfallen als der aktuelle Preis.',
      understood: 'Ich habe verstanden',
      modalTitle: 'Warum wird mir „Niedrigster Preis der letzten 30 Tage“ angezeigt?',
      modalParagraph1:
        'Aufgrund neuer EU-Gesetzgebung haben wir „Niedrigster Preis in den letzten 30 Tagen“ hinzugefügt. Dies hilft sowohl uns als auch unseren Kunden, rechtzeitig transparenter über Produktpreisänderungen zu informieren.<br><br>Beispielsweise betrug der niedrigste Preis des Produkts in den letzten 30 Tagen vor Beginn der neuen Verkaufskampagne (z. B. „Winterschlussverkauf“) 100,00 EUR. Dieser Preis wird als „Niedrigster Preis der letzten 30 Tage“ aufgeführt, wenn wir die erste Preissenkung (z. B. 90,00 EUR) in der neu gestarteten Kampagne ankündigen. Der „Niedrigste Preis der letzten 30 Tage“ bleibt während der gesamten Aktion gleich, auch wenn es innerhalb der gleichen Aktion zu weiteren Preissenkungen kommt (z. B. 80,00 EUR, 70,00 EUR usw.).',
      modalTitle2: 'Warum wird mir „Niedrigster Preis der letzten 30 Tage“ angezeigt?',
      modalParagraph2:
        'Gemäß der neuen EU-Preisauszeichnungsverordnung wird bei jeder kommunizierten Werbeaktion der von uns angewandte sogenannte „bisherige Preis“ angegeben. Was der Gesetzgeber als „vorheriger Preis“ bezeichnet, nennen wir „Niedrigster Preis der letzten 30 Tage“.',
      euLegislationLinkTitle:
        'Weitere Informationen zur neuen EU-Gesetzgebung zur Preisauszeichnung finden Sie auf dieser Website.',
      euLegislationLink:
        'https://commission.europa.eu/law/law-topic/consumer-protection-law/unfair-commercial-practices-and-price-indication/price-indication-directive_en',
    },
    msrp: 'UVP',
    availability: {
      green: 'Auf Lager',
      yellow: 'Nachschub ist unterwegs',
      red: 'Bald wieder verfügbar',
    },
    shippingConditionsText:
      'Für Porto und Verpackung berechnen wir eine Versandkostenpauschale in Höhe von <b>4,95 €</b>.<br><br>Ab 49 € ist deine Bestellung <b>VERSANDKOSTENFREI!</b>',
  },
  habaProductVariants: {
    color: 'Farbe',
    size: 'Größe',
    chooseSize: 'Grösse auswählen',
    soldOut: 'Ausverkauft',
    notifyMe: 'Benachrichtigen',
    toSizeTable: 'Zur Größentabelle',
    selectSize: 'Größe wählen',
  },
  habaProductPersonalization: {
    personalisation: 'Personalisierung',
    spaceForInformation: 'Platz für deine Angaben',
    font: 'Schriftart',
    entries: 'Deine Angaben',
    headline: 'Produkt personalisieren',
    remove: 'Entfernen',
    edit: 'Bearbeiten',
    successfullyAddedTitleNotification: 'Produkt erfolgreich personalisiert',
    successfullyAddedMessageNotification:
      'Der Preis wurde einschließlich der Personalisierungskosten aktualisiert',
    successfullyRemovedTitleNotification: 'Produktpersonalisierung',
    successfullyRemovedMessageNotification: 'Wurde erfolgreich entfernt.',
    subheadline:
      'Diesen Artikel personalisieren wir für zuzüglich <strong>{{price}} je Stück</strong> ganz nach deinem Wunsch.',
    blockWriting: 'Druckschrift',
    handWriting: 'Schreibschrift',
    errorTextLimitation: 'Platz für deine Angaben: 1 Zeile mit 20 Zeichen',
    textInputLabel: 'Bitte personalisierten Text eingeben *',
    exclusionLabel:
      'Hinweis: Personalisierte Artikel haben eine 1-2 Tage längere Lieferzeit und sind vom Rückgaberecht ausgeschlossen.',
    close: 'Abbrechen',
    submit: 'Speichern',
    textInvalidMinLengthMessage: 'Der Text muss länger als ein Buchstabe sein.',
    textInvalidMaxLengthMessage: 'Die maximale Zeichenanzahl ist erreicht.',
    textInvalidCharSetMessage:
      'Fehler Personalisierung Die Eingabe ist beschränkt auf lateinische Buchstaben und Zahlen.',
  },
};
